module.exports = __webpack_public_path__ + "static/media/WI2.4cc28769.png";